export default __webpack_public_path__ + "static/media/banner_image.376ab625.jpg";